import { StyleColorSchemeType } from '@/ui-kit/styles/enums';

const emptyCallback = () => {};

export default class BaseAction {
  colorSchema = StyleColorSchemeType.Secondary;
  #successHandler = null;
  #errorHandler = null;

  constructor({ successHandler, errorHandler, isDisabled = false }) {
    this.isDisabled = isDisabled;
    this.#successHandler = successHandler || emptyCallback;
    this.#errorHandler = errorHandler || emptyCallback;
  }

  async propagateResult(item, wasExecutionSucceed) {
    if (wasExecutionSucceed) {
      this.#successHandler(item);
    } else {
      this.#errorHandler(item);
    }
  }
}
